var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { I18NLink } from "../I18N";
import { actions } from "../BasicReducer";
import { store } from "../store";

export class SiteName extends Component {
  render() {
    return (/*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Helmet, {
        titleTemplate: `%s • ${this.props.siteName}`,
        meta: [{ 'char-set': 'utf-8' }, { name: 'description', content: 'Uwazi docs' }] }
      ), /*#__PURE__*/
      _jsx(I18NLink, {
        to: "/",
        onClick: () => store.dispatch(actions.set('library.sidepanel.view', 'library')) }, void 0,

      this.props.siteName
      )
      ));

  }
}





export function mapStateToProps(state) {
  return { siteName: state.settings.collection.get('site_name') };
}

export default connect(mapStateToProps)(SiteName);